import React from 'react';
import './Featureseng.css';

// ✅ Apni images yahan import karo (make sure sahi path ho)
import energyImg from '../../../imgs/Energysav.webp';
import syncImg from '../../../imgs/Synchronized.webp';
import compressionImg from '../../../imgs/Compre.webp';
import fastImg from '../../../imgs/Fastresponse.webp';

const features = [
  {
    title: 'Energy Saving',
    description: 'Compare to the traditional hydraulic injection molding machine, Powerjet all electric series only take 35% of the energy consumption.',
    img: energyImg
  },
  {
    title: 'Synchronized Drives',
    description: 'By using synchronous movement, circle time is greatly shortened, thus easily realizing high efficiency production.',
    img: syncImg
  },
  {
    title: 'Compression Molding',
    description: 'It’s possible to freely programmed the mold movements to synchronize with the injection movements.',
    img: compressionImg
  },
  {
    title: 'Fast Response',
    description: 'High response servo motor, high rigid power unit, superior injection response and holding force, ensure the quality and consistency of products.',
    img: fastImg
  }
];

const Featureseng = () => {
  return (
    <div className="features-container">
      <h2> FEATURES</h2>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div className="feature-card" key={index}data-aos="fade-up" >
            <img src={feature.img} alt={feature.title} className="feature-img" />
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
            <button className="learn-btn">Learn More</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Featureseng;
